const Router = {
    router: {
        query: {
            // guarantee: 0,
            // price: 0,
            // device: 1,
            // brand: 1,
            // model: 2,
            // status: -1,
            // reparation: 27909,
            // step:0
        }
    },
    push: () => { console.log('push') },
    back: () => { console.log('back') }
}

export default Router;